import { FC, memo } from "react";

interface Props {
  icon: JSX.Element;
  disabled?: boolean;
  className?: string;
  onClick?: () => void;
  type?: JSX.IntrinsicElements["button"]["type"];
}

const IconButtonBase: FC<Props> = ({
  icon,
  disabled,
  className,
  onClick,
  type = "button",
}) => {
  const classNames = [
    className,
    "p-2 bg-white rounded-lg border-2 disabled:opacity-30",
  ].join(" ");

  return (
    <>
      <button
        type={type}
        className={classNames}
        onClick={onClick}
        disabled={disabled}
      >
        {icon}
      </button>
    </>
  );
};

export const IconButton = memo(IconButtonBase);
